import { render, staticRenderFns } from "./Guests.vue?vue&type=template&id=2f22424e&"
import script from "./Guests.vue?vue&type=script&lang=js&"
export * from "./Guests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports